import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  List,
  ListItem,
  Typography,
  styled,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import 'animate.css';
// menu
import DrawerItem from "./DrawerItem";
// rotas
import { Link } from "react-router-dom";
// selector de idiomas
import LanguageSelector from "../components/LanguageSelector";
// traducciones
import { useTranslation } from "react-i18next";

// Logo para el Navbar (versión pequeña)
const NavbarLogo = styled(Box)(({ theme }) => ({
  width: '50px',
  height: '50px',
  borderRadius: '50%',
  backgroundColor: '#000000',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0.5),
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
  cursor: 'pointer',
  position: 'relative',
  animation: 'logoFloat 3s ease-in-out infinite',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '-10px',
    left: '-10px',
    right: '-10px',
    bottom: '-10px',
    borderRadius: '50%',
    background: 'linear-gradient(45deg, #ff0000, #ff7300, #fffb00, #48ff00, #00ffd5, #002bff, #7a00ff, #ff00c8, #ff0000)',
    backgroundSize: '400% 400%',
    animation: 'gradientRotate 5s ease infinite, colorShift 8s ease infinite',
    zIndex: -1,
    filter: 'blur(15px)',
    opacity: 1,
  },
  [theme.breakpoints.down('sm')]: {
    width: '45px',
    height: '45px',
  },
}));

const LogoMainText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontWeight: 'bold',
  fontSize: '1rem',
  textAlign: 'center',
  textTransform: 'uppercase',
  fontFamily: '"Montserrat", sans-serif',
  lineHeight: 1,
  marginBottom: '1px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.85rem',
  },
}));

// personalizacao
const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
});

const ListMenu = styled(List)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("sm")]: {
    display: "flex",
  },
}));

const Navbar = () => {
  const { t } = useTranslation();

  //rotas
  const itemList = [
    {
      text: t("nav.home"),
      to: "/",
    },
    {
      text: t("nav.academy"),
      to: "/academy",
    },
    /* {
      text: t("nav.about"),
      to: "/about",
    }, */
    {
      text: t("nav.blog"),
      to: "/blog",
    },
    {
      text: t("nav.contact"),
      to: "/contact",
    },
  ];

  return (
    <>
      <style>
        {`
          @keyframes logoFloat {
            0%, 100% {
              transform: translateY(0px);
            }
            50% {
              transform: translateY(-8px);
            }
          }
          @keyframes gradientRotate {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }
          @keyframes colorShift {
            0% {
              filter: hue-rotate(0deg) blur(15px);
            }
            25% {
              filter: hue-rotate(90deg) blur(15px);
            }
            50% {
              filter: hue-rotate(180deg) blur(15px);
            }
            75% {
              filter: hue-rotate(270deg) blur(15px);
            }
            100% {
              filter: hue-rotate(360deg) blur(15px);
            }
          }
        `}
      </style>
      <AppBar
        component="nav"
        position="sticky"
        sx={{
          backgroundColor: "white",
          border: "1px solid rgba(0, 0, 0, 0.2)",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
          marginBottom: "20px", // Espacio inferior
        }}
        elevation={0}
      >
      <StyledToolbar>
        <Box
          component={Link}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            gap: 1,
          }}
        >
          <NavbarLogo className="animate__animated animate__pulse animate__infinite animate__slow">
            <LogoMainText>PXT</LogoMainText>
          </NavbarLogo>
          <Typography
            variant="h6"
            component="h1"
            sx={{
              color: 'black',
              fontWeight: 600,
              fontSize: '1.2rem',
              display: { xs: 'none', sm: 'block' },
            }}
          >
            PeopleForTech
          </Typography>
        </Box>
        <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center", gap: 2 }}>
          <ListMenu>
            {itemList.map((item) => {
              const { text } = item;
              return (
                <ListItem key={text}>
                  <ListItemButton
                    component={Link}
                    to={item.to}
                    sx={{
                      color: "black",
                      "&:hover": {
                        backgroundColor: "transparent",
                        color: "#1e2a5a",
                      },
                    }}
                  >
                    <ListItemText primary={text} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </ListMenu>
          <LanguageSelector />
        </Box>
        <Box sx={{ display: { xs: "flex", sm: "none" }, alignItems: "center", gap: 1 }}>
          <LanguageSelector />
          <DrawerItem />
        </Box>
      </StyledToolbar>
    </AppBar>
    </>
  );
};

export default Navbar;
